<template>
  <div>
    <small class="d-table panel mb-3 cinza4 w-100">
      <p class="text-uppercase d-flex align-items-center font-weight-bold">
        Informações da compra
      </p>
      <hr />
      <p class="small">
        - Os valores serão registrados em suas faturas futuras
      </p>
      <div class="form_padrao">
        <div v-if="false" class="form-group">
          <label class="small mt-4 mb-1" for="parcelas">Parcelamento</label>
          <select
            name="parcelas"
            id="parcelas"
            v-model="card.parcelamento"
            placeholder="Selecione"
          >
            <option value="1">1x</option>
            <option value="2">2x</option>
            <option value="3">3x</option>
          </select>
        </div>
        <div v-if="false" class="form-check d-flex align-items-center">
          <input
            type="checkbox"
            id="ciente"
            v-model="card.aceite"
            name="ciente"
          /><label for="ciente" class="small pt-2"
            >Aceito os
            <a href="javascript:void(0)"
              >termos de uso e política de vendas</a
            ></label
          >
        </div>
      </div>
      <button
        type="submit"
        class="btn btn-verde mt-3 w-100"
        :disabled="loading"
        @click="acao"
      >
        <span
          class="spinner-grow spinner-grow-sm pr-2"
          role="status"
          aria-hidden="true"
          v-show="loading"
        ></span>
        <span v-if="loading">processando pagamento</span>
        <span v-else>Registrar boleto</span>
      </button>
    </small>
  </div>
</template>
<script>
export default {
  name: "ItemCard",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      card: {
        parcelamento: 1,
        dataaceite: new Date(),
        iporigem: "",
        browserdata: navigator.appVersion,
        aceite: true,
        datarevisaO_TERMO: new Date(),
      },
    };
  },
  methods: {
    acao() {
      this.$emit("click", {
        props: {
          boleto: true,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.alert {
  line-height: 1.4;
  strong {
    font-weight: 700;
  }
}
.item-card {
  text-align: center;
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 25px 10px;
  justify-content: space-between;
  align-items: center;
  color: #6c757d;
  margin-right: 5px;
  .item-card-valor {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    color: #000;
  }
  .item-card-titulo {
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
hr {
  color: #e9ecef !important;
  border-color: #e9ecef !important;
  border-width: 2px;
}
</style>
